import {fileSrc} from '../../../_component/fileUtils'
import {useAuth} from '../../../app/modules/auth'

export const LayoutSplashScreen = () => {
  const {school} = useAuth()
  return (
    <div id='splash-screen' className='splash-screen'>
      <img
        src={school?.logo ? fileSrc(school?.logo) : '/media/logos/starlight-logo.png'}
        id='splash-screen-image'
        alt='School logo'
        width='100'
      />
      <span className='loading'></span>
    </div>
  )
}
